import makeStyles from '@mui/styles/makeStyles';
import styled from 'styled-components';

export const IconContainer = styled.div`
  align-items: center;
  background: grey;
  display: flex;
  height: 50px;
  justify-content: center;
  width: 50px;
`;
IconContainer.displayName = 'IconContainer';

export const ImagePreview = styled.img`
  background: grey;
  height: 50px;
  object-fit: contain;
  width: 50px;
`;
ImagePreview.displayName = 'ImagePreview';

export const InputPreview = styled.input`
  background: grey;
  border: 0;
  flex: 1;
  height: 50px;
`;
InputPreview.displayName = 'InputPreview';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
  },
}));
